/**
 * Leave the SPA for a URL — the API (`/v1/…/admin/open`, which 302s on
 * to a site) or another origin. `window.location.assign` behind a
 * function so a test can see where a page would have gone: jsdom
 * implements no navigation, and a component that assigns `location`
 * directly can only be observed by the "not implemented" error it logs.
 */
export function leave(url: string): void {
  window.location.assign(url);
}

/** Load this page again from the server (stale-chunk.ts), behind a function for the same reason. */
export function reloadPage(): void {
  window.location.reload();
}
